<template>
  <v-container>
    <v-dialog v-model="detailsDialog" max-width="900px">
      <v-card class="pa-3" v-if="groupDetails">
          <span class="title text--primary">Group List</span>
        <v-row class="pa-0 ma-0" justify="center">
          <v-col md="4" v-for="group in groupDetails.groups" class="text-center" :key="group.id">
              <v-btn width="100%" class="group-detail"><b>{{group.groupAlias}}</b></v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
      <v-dialog v-model="detailsDialog" max-width="900px" content-class="dialog-task">
        <template v-if="groupDetails">
          <v-data-table 
          style="border-radius: 16px; font-weight: 600;"
          height="500px"
          fixed-header
          :items-per-page="groupDetails.length"
          :search="searchGroups"
          :items="groupDetails"
          :headers="groupHeaders"
          :no-data-text="$t('no_data')"
          class="elevation-1 pt-10 pr-7 pl-7 pb-0 ma-0 table-dialog"
           hide-default-footer
          >
           <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
            <template v-slot:top>
              <v-toolbar flat class="group-toolbar pt-5 mb-5">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0">
                    <v-text-field
                    class="toolbar-field"
                    hide-details
                    :label="$t('search_group_name')"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    v-model="searchGroups"
                    ></v-text-field>
                  </v-col>
                  <v-col md="12" class="ma-0 pa-0">
                    <v-toolbar-title class="pa-5 pl-0 mb-5 d-flex align-center"><span class="group-list-title">{{$t('group_list')}}</span><span class="group-list-title-badge">{{groupDetails.length}}</span></v-toolbar-title>
                  </v-col>
              </v-row>
              </v-toolbar>
            </template>
            <template v-slot:item.index="{ item }">
              <span>{{ groupDetails.indexOf(item) + 1 }}</span>
            </template>
          </v-data-table>
        </template>
        <!-- <v-col md="4" v-for="group in groupDetails.groups" class="text-center" :key="group.id">
        <v-btn width="100%" class="group-detail"><b>{{group.groupAlias}}</b></v-btn>
        </v-col> -->
      </v-dialog>
    <v-dialog v-model="addTaskDialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col>
            <v-btn
              right
              color="primary"
              dark
              class="mb-2"
              v-on="on"
              @click="addedItem()"
              >{{$t('add_task')}}</v-btn
            >
          </v-col>
          <v-col md="6">
            <v-text-field
              hide-details
              :label="$t('find_a_category')"
              prepend-inner-icon="mdi-magnify"
              single-line
              v-model="search"
              :rules="[validator.alfaNumberNotRequired]"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <v-form v-model="valid" ref="addForm">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{$t('add_category')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('task_code')"
                    :rules="[...rules, validator.alfaNumberNotRequired]"
                    v-model="addItem.categoryCode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('task_name')"
                    :rules="[...rules, validator.alfaNumberNotRequired]"
                    v-model="addItem.categoryName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    v-model="addItem.groupAccess"
                    :items="groupList"
                    item-text="alias"
                    item-value="id"
                    :label="$t('group')"
                    :rules="rules2"
                    multiple
                    small-chips
                    clearable
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              addItem.groupAccess.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                          >
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                          {{$t('select_all')}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                @click="addTask(addItem)"
                :disabled="!valid"
                >{{$t('save')}}</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="editTaskDialog" max-width="500px">
       <v-form v-model="valid2">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{$t('edit_category')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('task_code')"
                    v-model="editItem.categoryCode"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('task_name')"
                    v-model="editItem.categoryName"
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    v-model="editItem.groups"
                    :items="groupList"
                    item-text="alias"
                    item-value="id"
                    :label="$t('group')"
                    multiple
                    small-chips
                    :rules="rules3"
                    clearable
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggleEdit">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              editItem.groups.length > 0 ? 'indigo darken-4' : ''
                            "
                          >
                            {{ iconEdit }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{$t('select_all')}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                color="primary"
                :loading="loading"
                @click="editTask(editItem)"
                :disabled="!valid2"
                >{{$t('save')}}</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="deleteTaskDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_category')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteTaskDialog = false"
            >{{$t('save')}}</v-btn
          >
          <v-btn color="error" @click="deleteTask(itemToDelete.id)"
            >{{$t('delete')}}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :search="search"
      :items="task_list"
      :headers="headers"
      class="elevation-1 mt-3"
      :no-data-text="$t('no_data')"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page')  }"
    >
     <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" color="primary" @click="editedItem(item)"
          >mdi-pencil</v-icon
        >
        <v-icon small color="error" @click="deleteItem(item)"
          >mdi-delete</v-icon
        >
      </template>
      <template v-slot:item.group="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <b
              @click="openDetailsDialog(item)"
              v-bind="attrs"
              v-on="on"
              class="cursor text-primary"
            >{{item.groups.length}}</b>
          </template>
          <span>Click for see the full groups</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

export default {
  name: "task",
  data() {
    return {
      headers: [
        { text: this.$i18n.t('task_code'), value: "categoryCode" },
        { text: this.$i18n.t('task_name'), value: "categoryName"},
        { text: this.$i18n.t('total_group'), value: "group", align: "center" },
        { text: this.$i18n.t('manage'), value: "action", width: "10%" },
      ],
      groupHeaders: [
        { text: "No.", value: "index", align: "left", width: "10%", sortable: false },
        { text: this.$i18n.t('name'), value: "groupAlias", align: "left", sortable: false }
      ],
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      user_id: this.$store.state.user.id,
      task_list: [],
      search: "",
      alert_text: "",
      searchGroups: "",
      detailsDialog: false,
      addItem: {
        categoryCode: "",
        categoryName: "",
        groupAccess: [],
      },
      editItem: {
        categoryCode: "",
        categoryName: "",
        groups: [],
      },
      itemToDelete: {
        id: "",
      },
      task: [
        {
          id: "",
        },
      ],
      groupDetails: [],
      addTaskDialog: false,
      deleteTaskDialog: false,
      editTaskDialog: false,
      loading: false,
      editedIndex: -1,
      rules: [(v) => !!v || this.$i18n.t('required')],
      rules2: [(v) =>  v.length>0 || this.$i18n.t('required')],
      rules3: [(v) =>  v.length>0 || this.$i18n.t('required')],
      valid: true,
      valid2: true,
      task_id: [],
      groupList: [],
    };
  },
  computed: {
    addAllGroup() {
      return this.addItem.groupAccess.length === this.groupList.length;
    },
    addAll() {
      return this.addItem.groupAccess.length > 0 && !this.addAllGroup;
    },
    editAllGroup() {
      return this.editItem.groups.length === this.groupList.length;
    },
    editAll() {
      return this.editItem.groups.length > 0 && !this.editAllGroup;
    },
    icon() {
      if (this.addAllGroup) return "mdi-close-box";
      if (this.addAll) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconEdit() {
      if (this.editAllGroup) return "mdi-close-box";
      if (this.editAll) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    openDetailsDialog(item) {
      this.searchGroups = '';
      this.detailsDialog = true;
      this.groupDetails = item.groups;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.addAllGroup) {
          this.addItem.groupAccess = [];
        } else {
          this.addItem.groupAccess = this.groupList.slice();
        }
      });
    },
    toggleEdit() {
      this.$nextTick(() => {
        if (this.editAllGroup) {
          this.editItem.groups = [];
        } else {
          this.editItem.groups = this.groupList.slice();
        }
      });
    },
    addedItem() {
      this.addTaskDialog = true;
    },
    editedItem(item) {
      this.editedIndex = this.task.indexOf(item);
      const tmp = [];
      item.groups.map((edit) => {
        tmp.push(edit.groupId);
      });
      this.editItem = Object.assign({}, item);
      this.editItem.groups = tmp;
      this.editTaskDialog = true;
      this.getTaskList();
    },
    deleteItem(item) {
      this.itemToDelete = Object.assign({}, item);
      this.deleteTaskDialog = true;
    },
    close() {
      this.addTaskDialog = false;
      this.editTaskDialog = false;
      this.deleteTaskDialog = false;
    },
    async getTaskList() {
      const result = await this.$store.dispatch('getTaskAssignment')
      this.task_list = result;
      this.task_id = result;
    },
    async addTask(item) {
      this.loading = true;
      let groupAccess = [];
      if (this.icon == "mdi-close-box") {
        item.groupAccess.map((e) => {
          groupAccess.push(e.id);
        });
      } else {
        groupAccess = this.addItem.groupAccess;
      }
      const body = {
        categoryCode: item.categoryCode,
        categoryName: item.categoryName,
        groupAccess,
      }
      const result = await this.$store.dispatch('saveTaskAssignment', body)
      this.loading = false;
      if (result) {
        this.addTaskDialog = false;
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.getTaskList();
      } else {
        this.addTaskDialog = true;
      }
    },
    async editTask(item) {
      this.loading = true;
      let group = [];
      
      if (this.iconEdit == "mdi-close-box") {
        item.groups.map((e) => {
          if(e.id){
            group.push(e.id);
          }else{
            group.push(e);
          }
        });
      } else {
        group = this.editItem.groups
      }
      const body = {
        id: item.id,
        categoryName: item.categoryName,
        group
      }
      const result = await this.$store.dispatch('editTaskAssignment', body)
      this.loading = false;
      if (result) {
        this.editTaskDialog = false;
        this.showMessage('success', 'Data Successfully Edited')
        this.getTaskList();
      }
    },
    async deleteTask(id) {
      const result = await this.$store.dispatch('deleteTaskAssignment', {id})
      if (result) {
        this.deleteTaskDialog = false;
        this.getTaskList();
        this.showMessage('success', this.$i18n.t('alert_delete'))
      }
    },
    async fetchGroupDetails() {
      this.groupList = await this.$store.dispatch('getTaskAssignmentByRole', { userId: this.user_id })
    },
  },
  created() {
    this.getTaskList();
    this.fetchGroupDetails();
    // coment
  },
  watch: {
    addTaskDialog() {
      if (this.$refs.addForm) {
        this.$refs.addForm.reset();
      }
    },
  },
};
</script>
<style>
.group-detail {
  pointer-events: none
}


.group-toolbar > .v-toolbar__content, .group-toolbar > .v-toolbar__extension.group-toolbar {
    padding: 0;
}

.toolbar-field {
  font-weight: 400 !important;
}
 .v-application--is-ltr .v-text-field.toolbar-field .v-input__prepend-inner {
   padding: 8px;
   margin-left: 20px;
}


.v-data-table.table-dialog > .v-data-table__wrapper > table {
    margin-top: 20px;
}

.group-list-title{
  font-weight: 600;
  font-size: 24px;
  margin-right: 10px;
}

.table-dialog .text-left {
  padding: 0px !important;
}

.group-list-title-badge {
  color: white;
  border-radius: 20px;
  font-size: 16px;
  line-height: 23px;
  height: 23px;
  min-width: 40px;
  text-align: center;
  font-weight: 500;
  background-color: #1976D2;
  margin-left: 10px;
}

.v-data-table--fixed-header.table-dialog > .v-data-table__wrapper > table > thead > tr > th::after {
  content: '';
  bottom: 0;
  height: 1px;
  width: 200%;
  background: #ffffff !important;
  position: absolute;
  z-index: 99;
  margin-left: -20%;
}

.v-data-table--fixed-header.table-dialog > .v-data-table__wrapper {
  overflow-x: hidden !important;
}

.dialog-task {
  border-radius: 16px !important;
} 

</style>
